<template>
    <div class="view budget-tasks" v-if="loaded">
        <app-sub-navbar parent="budget"></app-sub-navbar>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <el-card class="box-card">
                        <app-graph-filter @filterLoaded="loadTable = true"  class="text-center" @filterChanged="redrawComponents()" parent="budget"></app-graph-filter>
                    </el-card>
                </div>
            </div>

            <div class="spacer col-12"></div>

            <div class="row">
                <div class="col-12">
                    <el-card class="box-card" v-if="loadTable === true" v-loading="loading">
                        <!-- I know this is redundant but needed for redrawComponent -->
                        <app-performance-table @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType === 'Budget' && $store.state.graphFilter.performanceStoreWeek === 'Store'" ref="budgetTable1" title="performanceTable" endpoint="/budget/analytics/total_vs_budget"></app-performance-table>
                        <app-performance-table @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType !== 'Budget' && $store.state.graphFilter.performanceStoreWeek === 'Store'" ref="lflTable1" title="performanceTable" endpoint="/budget/analytics/total_vs_lastyearlfl"></app-performance-table>
                        <app-performance-table @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType === 'Budget' && $store.state.graphFilter.performanceStoreWeek !== 'Store'" ref="budgetTable1week" title="performanceTable" endpoint="/budget/analytics/total_vs_budget"></app-performance-table>
                        <app-performance-table @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType !== 'Budget' && $store.state.graphFilter.performanceStoreWeek !== 'Store'" ref="lflTable1week" title="performanceTable" endpoint="/budget/analytics/total_vs_lastyearlfl"></app-performance-table>
                    </el-card>
                </div>
            </div>

            <div class="small-spacer col-12"></div>

            <div class="row" ref="stickyRow">
                <div class="col-12">
                    <el-card class="box-card" v-if="loadTable === true" v-loading="loading">
                        <app-performance-table :class="{ 'table-fixed-header': isFixed }" @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType === 'Budget' && $store.state.graphFilter.performanceStoreWeek === 'Store'" ref="budgetTable2" title="performanceTable" endpoint="/budget/analytics/stores_vs_budget"></app-performance-table>
                        <app-performance-table :class="{ 'table-fixed-header': isFixed }" @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType !== 'Budget' && $store.state.graphFilter.performanceStoreWeek === 'Store'" ref="lflTable2" title="performanceTable" endpoint="/budget/analytics/stores_vs_lastyearlfl"></app-performance-table>
                        <app-performance-table :class="{ 'table-fixed-header': isFixed }" @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType === 'Budget' && $store.state.graphFilter.performanceStoreWeek !== 'Store'" ref="budgetTable2week" title="performanceTable" endpoint="/budget/analytics/stores_vs_budget_week"></app-performance-table>
                        <app-performance-table :class="{ 'table-fixed-header': isFixed }" @dataLoaded="loading = false" v-if="$store.state.graphFilter.performanceType !== 'Budget' && $store.state.graphFilter.performanceStoreWeek !== 'Store'" ref="lflTable2week" title="performanceTable" endpoint="/budget/analytics/stores_vs_lastyearlfl_week"></app-performance-table>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import PerformanceTableFilter from '../../components/budget/PerformanceTableFilter'
import PerformanceTable from '../../components/budget/PerformanceTable'

export default {
    data () {
        return {
            loaded: false,
            loadTable: false,
            loading: false,
            isFixed: false
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appGraphFilter: PerformanceTableFilter,
        appPerformanceTable: PerformanceTable
    },
    methods: {
        redrawComponents () {
            this.loading = true
            for (let i in this.$refs) {
                if (i.includes('lfl') && this.$store.state.graphFilter.performanceType !== 'Budget' && i.includes('week') && this.$store.state.graphFilter.performanceStoreWeek !== 'Store') {
                    this.$refs[i].update()
                } else if (i.includes('budget') && this.$store.state.graphFilter.performanceType === 'Budget' && i.includes('week') && this.$store.state.graphFilter.performanceStoreWeek !== 'Store') {
                    this.$refs[i].update()
                } else if (i.includes('lfl') && this.$store.state.graphFilter.performanceType !== 'Budget' && !i.includes('week') && this.$store.state.graphFilter.performanceStoreWeek === 'Store') {
                    this.$refs[i].update()
                } else if (i.includes('budget') && this.$store.state.graphFilter.performanceType === 'Budget' && !i.includes('week') && this.$store.state.graphFilter.performanceStoreWeek === 'Store') {
                    this.$refs[i].update()
                }
            }
        },
        handleScroll () {
            // Get the y position of the table relative to the user window.
            const rowPosition = this.$refs['stickyRow'].getBoundingClientRect().y
            // If negative, we've already passed the table, so isFixed=true
            this.isFixed = rowPosition < 0
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll)

        if (this.$store.getters['budget/storesLoaded'] === false && this.$store.getters['general/storesLoaded'] === true) {
            this.$store.commit('budget/SET_STORES', this.$store.getters['general/getStores'])
            this.loaded = true
            this.redrawComponents()
        } else if (this.$store.getters['budget/storesLoaded'] === false && this.$store.getters['general/storesLoaded'] === false) {
            this.$store.dispatch('general/getStores').then(response => {
                this.$store.commit('budget/SET_STORES', this.$store.getters['general/getStores'])
                this.loaded = true
                this.redrawComponents()
            })
        } else {
            this.loaded = true
            this.redrawComponents()
        }
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}

</script>
<style>
.table-fixed-header .el-table__header {
    position: fixed;
    top: 0px;
    z-index: 1;
}
.padding-20 {
    padding-left: 20px;
    padding-right: 20px;
}
</style>
